import FastMarquee from "react-fast-marquee";

export const Marquee = ({ text, theme = "dark" }) => {
  const isOcean = theme === "ocean";
  return (
    <div
      className={`border-y py-6 overflow-hidden ${isOcean ? "border-white/15 bg-ocean-mid" : "border-white/10 bg-ink"}`}
      data-testid="editorial-marquee"
    >
      <FastMarquee speed={26} gradient={false}>
        {Array.from({ length: 4 }).map((_, i) => (
          <span
            key={i}
            className={`font-syne text-xl md:text-2xl tracking-tight mx-5 ${isOcean ? "text-white/60" : "text-white/50"}`}
          >
            {text}
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};
